import { TAGS, api } from "../../api.ts"
import { IGetLeaderboardArgs } from "./season-leaderboard.types"

export const seasonLeaderboardAPI = api.enhanceEndpoints({
  addTagTypes: [TAGS.SEASON_LEADERBOARD]
})

export const seasonLeaderboardEndpoints = seasonLeaderboardAPI.injectEndpoints({
  endpoints: (builder) => ({
    getLeaderboard: builder.query<any, IGetLeaderboardArgs>({
      query: ({ type, locationIndex, seasonIndex }) => {
        let url = `/users/leaderboard/${type}?locationIndex=${locationIndex}`

        if (seasonIndex) {
          url += `&seasonIndex=${seasonIndex}`
        }

        return {
          url,
          method: "GET"
        }
      },
      providesTags: (_result, _error, { type, locationIndex, seasonIndex }) => [
        {
          type: TAGS.SEASON_LEADERBOARD,
          id: `LEADERBOARD`
        },
        {
          type: TAGS.SEASON_LEADERBOARD,
          id: `leaderboard-${type}-${locationIndex}-${seasonIndex}`
        }
      ]
    })
  })
})
